import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes/Routes';
import { CartProvider } from './Components/CartContext';
import { NotificationProvider } from './Components/NotificationContext';
import { CatalogProvider } from './Components/CatalogContext';
import './App.css';

function App() {
  return (
    <CatalogProvider>
      <CartProvider>
        <NotificationProvider>
          <BrowserRouter>
            <div className="App">
              <Routes />
            </div>
          </BrowserRouter>
        </NotificationProvider>
      </CartProvider>
    </CatalogProvider>
  );
}

export default App;
